import { HttpMethodEnum, HttpResponse } from '@ipevo-rd/service-web-utils'
import { v1HttpClient } from './index.js'
import {
	AppointmentsModifyReq,
	AppointmentsReq,
} from './dto/AppointmentsDTO.js'

export const Appointments = {
	/**
	 * 取得預約列表
	 * @return {Promise<HttpResponse>}
	 */
	get: (): Promise<HttpResponse> =>
		v1HttpClient.request({
			url: '/appointments',
			method: HttpMethodEnum.GET,
		}),

	/**
	 * 建立預約
	 * @param data {unknown} 資料
	 * @return {Promise<HttpResponse>}
	 */
	create: (data: unknown): Promise<HttpResponse> =>
		v1HttpClient.request({
			url: '/appointments',
			method: HttpMethodEnum.POST,
			data,
		}),

	/**
	 * 刪除預約
	 * @param dto {AppointmentsReq}
	 * @return {Promise<HttpResponse>}
	 */
	del: (dto: AppointmentsReq): Promise<HttpResponse> =>
		v1HttpClient.request({
			url: `/appointments/${dto.id}`,
			method: HttpMethodEnum.DELETE,
		}),

	/**
	 * 修改預約
	 * @param dto {AppointmentsModifyReq}
	 * @return {Promise<HttpResponse>}
	 */
	modify: (dto: AppointmentsModifyReq): Promise<HttpResponse> =>
		v1HttpClient.request({
			url: `/appointments/${dto.id}`,
			method: HttpMethodEnum.PUT,
			params: dto,
		}),
}
